import React, {useState, useEffect} from "react";
import {hopnLanguageArray} from "@/utils/functions.js";
import {WhyUs} from "../Components/whyUs.jsx";
import {HopnPerks} from "../Components/hopnPerks.jsx";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {storage, STORAGE_KEYS} from "@/utils/storage";
import {NGD_formatDate, NGD_formatTime} from "@/utils/filesConstants.js";
import {planeIcon, planeTakeOffSlim, arrowRightSlim, arrowLongDown} from "@img/index.js";
import {ModalFooter} from "../Components/BookingModalShell.jsx";

export function FlightAirportDetails(props) {
    const [destinationData, setDestinationData] = useState(null);
    const [departureAirport, setDepartureAirport] = useState(null);
    const [whyUsPopup, setWhyUsPopup] = useState(false);

    useEffect(() => {
        const parsedDestination = storage.get(STORAGE_KEYS.DESTINATIONS);
        if (Array.isArray(parsedDestination) && parsedDestination[0]?.types?.includes("airport")) {
            setDestinationData(parsedDestination[0]);
        }

        const storedDeparture = storage.get(STORAGE_KEYS.DEPARTURE_AIRPORT);
        if (storedDeparture) setDepartureAirport(storedDeparture);
    }, []);

    if (!destinationData) return null;

    const rawAirportName = destinationData.address.match(/\(([^)]+)\)/);
    const selectedAirportName = rawAirportName ? rawAirportName[1] : "";

    const rideDate = storage.get(STORAGE_KEYS.RIDE_DATE);
    const rideTime = storage.get(STORAGE_KEYS.RIDE_TIME);
    const hasDateTime = rideDate && rideTime;

    return (
        <>
            {whyUsPopup && (
                <div className="whyUs" hopn-data-category="second_banner">
                    <WhyUs setWhyUsPopup={setWhyUsPopup}/>
                </div>
            )}

            <ModalHeader
                title="Flight Details"
                extraClasses=""
                totalSteps={1}
                cancelButton={false}
                cancelButtonType="text"
                backStep="travelingDateTime"
                showBackButton={false}
                enableEditModeOnBackButton={false}
                setStep={props.setStep}
                closeModal={props.closeModal}
            />

            <div className="hopn-date-info-layout modalPages-spacing">
                <div className="inner-tab">
                    <div className="hopn-plane-header">
                        <div className="plane-img">
                            <span><img decoding="async" src={planeIcon} alt="plane icon"/></span>
                        </div>
                        <div className="plane-content">
                            <h3>Your flight to {selectedAirportName} <span>Add your flight details below</span></h3>
                        </div>
                    </div>

                    <div className="hopn-plane-details">
                        <button
                            className="hopn-plane-details-tab"
                            onClick={() => props.setStep("travelingDateTime")}
                        >
                            <h3>
                                Date and Time
                                {hasDateTime && (
                                    <span>
                                        {NGD_formatDate(rideDate)}, {NGD_formatTime(rideTime)}
                                    </span>
                                )}
                            </h3>

                            <div className="icon-button">
                                <img decoding="async" src={arrowRightSlim}/>
                            </div>
                        </button>

                        <button
                            onClick={() => props.setStep('flightAirportTo')}
                            className="hopn-plane-details-tab"
                        >
                            <h4>
                                <img decoding="async" src={planeTakeOffSlim}/>
                                {departureAirport ? `Flying from ${departureAirport.name} (${departureAirport.iata})` : "Where are you flying from?"}
                            </h4>

                            <div className="icon-button">
                                <img decoding="async" src={arrowRightSlim}/>
                            </div>
                        </button>
                    </div>

                    <ModalFooter>
                        <button
                            className="hopn-add-passenger-button time"
                            disabled={!hasDateTime}
                            onClick={() => {
                                if (hasDateTime) props.setStep('passengerQuantity');
                            }}
                        >
                            {hasDateTime
                                ? `Pick up at ${NGD_formatDate(rideDate)}, ${NGD_formatTime(rideTime)}`
                                : "Continue"}
                        </button>
                    </ModalFooter>
                </div>

                <div className="inner-tab hopn-banner-right">
                    <div className="hopn-banner-right-inner">
                        <HopnPerks key="1" sliderOnly modalStyle="popup"/>

                        <div className="find-driver">
                            <div className="find-driver-inner">
                                <h3>How do I find my driver at the airport?</h3>
                                <p>Here's a guide on where to proceed</p>
                            </div>
                            <button className="inner">
                                <img decoding="async" src={arrowLongDown} alt="Download Button"/>
                            </button>
                        </div>

                        <button className="clearStyle" onClick={() => setWhyUsPopup(true)}>
                            {hopnLanguageArray("second_banner", "more_airport_pickup_perks", "More airport pickup Perks")}
                            <span><img src={arrowRightSlim} alt="Arrow Right"/></span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}
export default FlightAirportDetails;
